import { Box, Flex } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const SkeletonHeader = () => {
  return (
    <Flex gap="16px" alignItems="center">
      <SkeletonComponent height="32px" width="32px" borderRadius="8px" />

      <Box width="120px">
        <SkeletonComponent height="19px" width="84px" mb="2px" />
        <SkeletonComponent height="16px" width="120px" />
      </Box>
    </Flex>
  );
};

export default SkeletonHeader;
